/* This example requires Tailwind CSS v2.0+ */
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";

export default function ConfirmationModal({
    showDialog,
    busy = false,
    onCancel,
    onConfirm,
    title,
    description,
}) {
    return (
        <Transition.Root show={showDialog} as={Fragment}>
            <Dialog as="div" className="relative z-[120]" onClose={() => { if (!busy) onCancel(); }}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-slate-900/70 backdrop-blur-[1px] transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-[130] overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                                <div>
                                    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100">
                                        <ExclamationCircleIcon
                                            className="h-6 w-6 text-red-600"
                                            aria-hidden="true"
                                        />
                                    </div>
                                    <div className="mt-3 text-center sm:mt-5">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-medium leading-6 text-gray-900"
                                        >
                                            {title}
                                        </Dialog.Title>
                                        <div className="mt-2">
                                            <p className="text-sm text-gray-500">
                                                {description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-5 sm:mt-6 flex items-center justify-between">
                                    <button
                                        type="button"
                                        disabled={busy}
                                        className="inline-flex w-full justify-center rounded-md border border-transparent bg-red-500 px-2 py-2 text-base font-medium text-white shadow-sm hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-red-500 focus:outline-none focus:ring-0 sm:text-sm mx-2"
                                        onClick={() => {
                                            onCancel();
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        disabled={busy}
                                        aria-busy={busy}
                                        aria-label={busy ? "Processing..." : undefined}
                                        className="inline-flex w-full items-center justify-center rounded-md border border-transparent bg-teal-500 px-2 py-2 text-base font-medium text-white shadow-sm hover:bg-teal-600 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-teal-500 focus:outline-none focus:ring-0 sm:text-sm mx-2"
                                        onClick={() => {
                                            onConfirm();
                                        }}
                                    >
                                        {busy && <span role="status" aria-label="Processing request" className="w-4 h-4 mr-2 border-2 border-white rounded-full border-t-transparent animate-spin" />}
                                        {busy ? "Processing..." : "Confirm"}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
